import { flexRender, type Header } from '@tanstack/react-table';
import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';
import { TableHead } from '@/components/ui/table';

export function SortableHeader<T>({ header }: { header: Header<T, unknown> }) {
  const { column } = header;
  const sorted = column.getIsSorted();
  const content = header.isPlaceholder
    ? null
    : flexRender(column.columnDef.header, header.getContext());

  if (!column.getCanSort()) {
    return <TableHead className={column.columnDef.meta?.headerClassName}>{content}</TableHead>;
  }

  const Icon = sorted === 'asc' ? ChevronUp : sorted === 'desc' ? ChevronDown : ChevronsUpDown;
  const label = column.columnDef.meta?.sortLabel ?? column.id;

  return (
    <TableHead
      className={column.columnDef.meta?.headerClassName}
      aria-sort={sorted === 'asc' ? 'ascending' : sorted === 'desc' ? 'descending' : undefined}
    >
      <button
        type="button"
        onClick={column.getToggleSortingHandler()}
        aria-label={`Sort by ${label}`}
        className="inline-flex items-center gap-1 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        {content}
        <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
    </TableHead>
  );
}
